/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { defaultCurrency } from "../../shared/constants/currency";
import * as elementsActions from "../../redux/actions/elements";
import styles from "./FullScreenCheckoutButton.module.css";
import "./CheckoutButtonBrandRefresh.module.css";
import {
  getCheckoutButtonBrandRefreshColors,
  getCheckoutButtonMenuProps,
  getCheckoutButtonPartProps,
  getCheckoutButtonRegionProps,
  getCheckoutCartIcon,
  isCheckoutButtonBrandRefresh
} from "./checkoutButtonBrandRefreshClasses";
import { getTotalPrice } from "../../shared/utilities/renderings";

const legacyCartImage = require("../Header/FullScreenHomepageHeader/NavigationBar/NavIcons/imgs/Cart.svg");
const brandRefreshCartOnYellow = require("./imgs/cart-icon-on-yellow.svg");
const brandRefreshCartOnCream = require("./imgs/cart-icon-on-cream.svg");

export class FullScreenCheckoutButton extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getCartTotals = () => {
    const { currency, order, userCart } = this.props;

    const hasRedeemables = order && order?.orderRedeemables?.length > 0;
    let redeemables = [];

    if (hasRedeemables) {
      redeemables = order?.orderRedeemables?.map(item => item.order_product_id);
    }

    const cartItem =
      userCart?.map(item => ({
        quantity: item.quantity,
        price: redeemables.includes(item.id)
          ? 0
          : getTotalPrice(item) * item.quantity
      })) || [];

    const cartQuantity = cartItem
      .map(item => item.quantity)
      .reduce((a, b) => a + b, 0);

    const cartPrice = cartItem
      .map(item => item.price)
      .reduce((a, b) => a + b, 0);

    return {
      cartQuantity,
      orderPrice: `${currency.symbol}${cartPrice.toFixed(2)}`
    };
  };

  render() {
    const { label, onClick, isMenuPage } = this.props;
    const { cartQuantity, orderPrice } = this.getCartTotals();
    const isBrandRefresh = isCheckoutButtonBrandRefresh();

    const handleClick = e => {
      if (onClick) {
        onClick(e);
      }
    };

    if (!isBrandRefresh) {
      return (
        <button
          type="button"
          className={`${styles.checkoutCartWrapper} flex items-center w-full text-white rounded-[30px]`}
          onClick={handleClick}
        >
          <div className={styles.checkoutCartButton}>
            <div className={styles.leftSection}>
              <p className={styles.checkoutCartLabel}>{label}</p>
            </div>
            <div className={styles.rightSection}>
              <div className={styles.cartIconWrapper}>
                <img alt="" src={legacyCartImage} className={styles.cartIcon} />
                <span className={styles.cartBadge}>
                  {cartQuantity > 99 ? "99+" : cartQuantity}
                </span>
              </div>
              <p>{orderPrice}</p>
            </div>
          </div>
        </button>
      );
    }

    const cartImage = getCheckoutCartIcon(
      legacyCartImage,
      brandRefreshCartOnYellow,
      brandRefreshCartOnCream,
      isMenuPage
    );
    const brandColors = getCheckoutButtonBrandRefreshColors(isMenuPage);

    return (
      <button
        type="button"
        className={styles.checkoutCartWrapper}
        onClick={handleClick}
        data-region={getCheckoutButtonRegionProps()}
        data-part={getCheckoutButtonPartProps("button")}
        data-menu={getCheckoutButtonMenuProps(isMenuPage)}
        style={{
          backgroundColor: brandColors.backgroundColor,
          color: brandColors.color
        }}
      >
        <div
          className={styles.checkoutCartButton}
          data-part={getCheckoutButtonPartProps("button-inner")}
        >
          <p data-part={getCheckoutButtonPartProps("label")}>{label}</p>
          <div data-part={getCheckoutButtonPartProps("right")}>
            <div data-part={getCheckoutButtonPartProps("cart-icon")}>
              <img alt="" src={cartImage} />
              <span
                data-part={getCheckoutButtonPartProps("qty")}
                style={{ color: brandColors.qtyColor }}
              >
                {cartQuantity > 99 ? "99+" : cartQuantity}
              </span>
            </div>
            <p>{orderPrice}</p>
          </div>
        </div>
      </button>
    );
  }
}

FullScreenCheckoutButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  currency: PropTypes.objectOf(PropTypes.string),
  order: PropTypes.shape({}),
  userCart: PropTypes.shape([{}]),
  isMenuPage: PropTypes.bool
};

FullScreenCheckoutButton.defaultProps = {
  currency: defaultCurrency,
  order: null,
  userCart: null,
  isMenuPage: false
};

export const mapStateToProps = state => {
  const { selectedStore, userAddress, userOrderMethod, userCart } = state.user;
  const { currency } = state.currency;
  const { order } = state;
  return {
    selectedStore,
    userAddress,
    userOrderMethod,
    currency,
    order,
    userCart
  };
};

export const mapDispatchToProps = dispatch => ({
  setModalObject: value => dispatch(elementsActions.setModalObject(value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FullScreenCheckoutButton);
